import { useUiEvent as useUiEventUtils } from '@lingoda/analytics';

/**
 * @deprecated use `useUiEvent` from `@lingoda/analytics` instead
 */
export const useUiEvent = useUiEventUtils;
